exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.task-status-container[data-v-f43a635c] {\n  padding: 20px;\n}\n.pagination-container[data-v-f43a635c] {\n  margin-top: 20px;\n  text-align: right;\n}\n", ""]);

// exports
